import { Icon, Popup } from 'semantic-ui-react';
import { FieldValueConfirmationType, FieldValueWarningType } from '../../../../types';
import { getInfoPopUpIconProps } from './utils';

type InfoPopupPropsType = {
    correction: number;
    warnings: FieldValueWarningType[];
    confirmations: FieldValueConfirmationType[];
    className?: string
};

function InfoPopup({ correction, warnings, confirmations, className = "" }: InfoPopupPropsType) {
    const { name, color } = getInfoPopUpIconProps(warnings, confirmations);
    return (
        <Popup
            on={'hover'}
            content={<PopupContent correction={correction} warnings={warnings} confirmations={confirmations} />}
            trigger={<Icon className={`flex flex-align-center flex-justify-center ${className}`} color={color} name={name} />}
        />
    );
}

type PopupContentPropsType = {
    correction: number;
    warnings: FieldValueWarningType[];
    confirmations: FieldValueConfirmationType[];
};
function PopupContent({ correction, warnings, confirmations }: PopupContentPropsType) {
    return (
        <>
            {!!correction && <p>Correction: {correction}</p>}
            <Messages title="Warnings" messages={warnings.map((w) => `${w.type} ${w.message}`)} />
            <Messages title="Confirmations" messages={confirmations.map((c) => `${c.type} ${c.message}`)} />
        </>
    );
}

type MessagesPropsType = {
    title: string;
    messages: string[];
};

function Messages({ title, messages }: MessagesPropsType) {
    return messages.length ? (
        <>
            <b>{title}</b>
            <br />
            <ul>
                {messages.map((m, i) => (
                    <li key={i}>{m}</li>
                ))}
            </ul>
        </>
    ) : (
        <></>
    );
}

export default InfoPopup;
